import React from "react";
export default function SVGBroken1() {
  return (
    <svg x="0px" y="0px" viewBox="0 0 511.995 511.995">
      <g>
        <g fill="#000000">
          <path
            fill="#000000"
            d="M237.273,323.149c-8.13-4.563-18.415-1.688-22.989,6.431c-3.196,5.688-8.023,9.655-14.775,12.142L66.237,391.008    l-27.665-74.685l133.171-49.242c7.573-2.751,16.148-2.25,22.939,1.322c8.254,4.355,18.454,1.182,22.798-7.072    c4.344-8.248,1.182-18.455-7.067-22.798c-15.298-8.057-33.601-9.216-50.289-3.151L11.025,290.521    c-4.203,1.553-7.607,4.709-9.48,8.783c-1.874,4.068-2.048,8.715-0.495,12.912l39.385,106.339    c2.521,6.808,8.974,11.022,15.833,11.022c1.941,0,3.916-0.343,5.851-1.058L211.2,373.386    c14.167-5.221,25.409-14.645,32.504-27.249C248.278,338.013,245.397,327.723,237.273,323.149z"
          />
        </g>
      </g>
      <g>
        <g fill="#000000">
          <path
            fill="#000000"
            d="M508.329,261.529c-2.791-3.505-6.859-5.756-11.303-6.262L339.11,237.279c-18.173-2.251-36.268,3.657-49.67,16.271    c-6.791,6.386-7.117,17.065-0.726,23.856c6.38,6.791,17.059,7.123,23.856,0.726c6.144-5.778,14.117-8.383,22.534-7.337    l141.323,16.091l-9.103,79.551l-141.661-16.125c-8.929-0.85-14.764-5.598-18.089-9.441c-6.11-7.039-16.767-7.798-23.811-1.705    c-7.044,6.105-7.809,16.767-1.705,23.811c10.414,12.018,24.767,19.45,40.099,20.902l158.107,18.004    c0.647,0.079,1.3,0.113,1.935,0.113c8.462,0,15.765-6.352,16.744-14.955l12.941-113.09    C512.397,269.501,511.114,265.034,508.329,261.529z"
          />
        </g>
      </g>
      <g>
        <g fill="#000000">
          <path
            fill="#000000"
            d="M260.696,82.418c-0.068,0-0.135,0-0.203,0c-9.227,0-16.761,7.427-16.873,16.682l-1.125,95.648    c-0.107,9.323,7.359,16.964,16.682,17.076c0.068,0,0.135,0,0.203,0c9.227,0,16.767-7.421,16.873-16.682l1.125-95.648    C277.485,90.172,270.018,82.531,260.696,82.418z"
          />
        </g>
      </g>
      <g>
        <g fill="#000000">
          <path
            fill="#000000"
            d="M212.089,184.233l-34.321-45.574c-5.604-7.449-16.181-8.946-23.636-3.331c-7.449,5.604-8.94,16.187-3.331,23.636    l34.321,45.574c3.32,4.405,8.378,6.724,13.498,6.724c3.533,0,7.1-1.103,10.139-3.393    C216.208,202.266,217.699,191.683,212.089,184.233z"
          />
        </g>
      </g>
      <g>
        <g fill="#000000">
          <path
            fill="#000000"
            d="M366.297,135.323c-7.455-5.609-18.027-4.119-23.636,3.331l-34.321,45.574c-5.609,7.449-4.113,18.027,3.331,23.636    c3.044,2.296,6.605,3.398,10.144,3.398c5.12,0,10.178-2.318,13.492-6.729l34.321-45.574    C375.237,151.51,373.741,140.933,366.297,135.323z"
          />
        </g>
      </g>
    </svg>
  );
}
